<template>
    <div>
        <!-- Botón imprimir -->
        <div align="center" class="mb-3">
            <vs-button @click="m_imprimirTodos('12px', nombrearchivo, '0px')" color="success" type="filled" icon-pack="feather" icon="icon-printer">
                Imprimir / Descargar PDF
            </vs-button>
        </div>

        <!-- Contenido a imprimir -->
        <vx-card id="seccionImprimir2" style="padding: 20px;">
            <!-- ENCABEZADO -->
            <table style="width: 100%; border-collapse: collapse;">
                <tr>
                    <td style="width: 15%; text-align: left; padding: 10px; vertical-align: top;">
                        <img class="img-responsive mb-2 ml-1" v-bind:src="datosProp" style="display: flex; width: 100px;">
                    </td>
                    <td style="width: 85%; text-align: center; vertical-align: top; padding-top: 10px;">
                        <p style="font-weight: bold; font-size: 18px; margin: 0;">PROMOCIÓN DE VENTAS</p>
                        <p style="font-weight: bold; font-size: 18px; margin: 5px 0 0 0;">ACTA DE ENTREGA</p>
                        <p style="font-weight: bold; font-size: 14px; margin: 10px 0 0 0;">{{ venta.ven_codigo }}</p>
                        <p style="font-weight: bold; font-size: 12px; margin: 10px 0 0 0;">Empresa: {{ venta.empresa_descripcion }}</p>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" style="font-size: 14px; text-align: left; padding-top: 10px;">
                        Quito, {{ mesd }}, {{ day }} de {{ mes }} del {{ year }}
                    </td>
                </tr>
            </table>

            <br>

            <!-- DATOS DEL CLIENTE -->
            <table style="width: 100%; border-collapse: collapse; font-size: 14px;">
                <tr>
                    <td style="width: 30%; font-weight: bold; text-align: left;">CLIENTE:</td>
                    <td style="width: 70%; text-align: left;">{{ venta.cliente_nombre }}</td>
                </tr>
                <tr>
                    <td style="width: 30%; font-weight: bold; text-align: left;">RUC / CI:</td>
                    <td style="width: 70%; text-align: left;">{{ venta.ruc_cliente }}</td>
                </tr>
                <tr>
                    <td style="width: 30%; font-weight: bold; text-align: left;">RESPONSABLE:</td>
                    <td style="width: 70%; text-align: left;">{{ venta.facturador_nombre }}</td>
                </tr>
                <tr>
                    <td style="width: 30%; font-weight: bold; text-align: left;">ASESOR:</td>
                    <td style="width: 70%; text-align: left;">{{ venta.asesor }}</td>
                </tr>
                <tr>
                    <td style="width: 30%; font-weight: bold; text-align: left;">PERÍODO:</td>
                    <td style="width: 70%; text-align: left;">{{ venta.periodoescolar }}</td>
                </tr>
                <tr>
                    <td style="width: 30%; font-weight: bold; text-align: left;">FECHA:</td>
                    <td style="width: 70%; text-align: left;">{{ venta.ven_fecha }}</td>
                </tr>
            </table>

            <br>

            <p style="font-size: 14px; text-align: justify;">
                Con esta fecha, se procede a la suscripción de la presente Acta de Entrega - Recepción de los productos que se otorgan en calidad de <b>OBSEQUIOS SIN COSTO</b>, como parte de la PROMOCIÓN DE VENTAS.
            </p>

            <br>

            <!-- TABLA DE DETALLE -->
            <div align="center">
                <table class="tabla2 mi-clase-de-tabla" align="center" style="border-collapse: collapse; font-size: 14px; width: 90%;">
                    <thead>
                        <tr>
                            <td width="120" style="text-align: center; border: 1px solid gray; padding: 6px;"><b>Cantidad</b></td>
                            <td width="500" style="text-align: center; border: 1px solid gray; padding: 6px;"><b>Descripción</b></td>
                            <td width="200" style="text-align: center; border: 1px solid gray; padding: 6px;"><b>Código</b></td>
                            <td width="150" style="text-align: center; border: 1px solid gray; padding: 6px;"><b>P. Unitario</b></td>
                            <td width="150" style="text-align: center; border: 1px solid gray; padding: 6px;"><b>Subtotal</b></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(det, key) in detalles" :key="key">
                            <td style="text-align: center; border: 1px solid gray; padding: 5px;">
                                {{ det.det_ven_cantidad }}
                            </td>
                            <td style="text-align: left; border: 1px solid gray; padding: 5px;">
                                {{ det.nombre_producto || det.pro_codigo }}
                            </td>
                            <td style="text-align: center; border: 1px solid gray; padding: 5px;">
                                {{ det.pro_codigo }}
                            </td>
                            <td style="text-align: center; border: 1px solid gray; padding: 5px;">
                                ${{ det.det_ven_valor_u }}
                            </td>
                            <td style="text-align: center; border: 1px solid gray; padding: 5px;">
                                ${{ (det.det_ven_cantidad * det.det_ven_valor_u).toFixed(2) }}
                            </td>
                        </tr>
                        <!-- Fila de totales -->
                        <tr v-if="detalles.length > 0">
                            <td colspan="4" style="text-align: right; border: 1px solid gray; padding: 5px; font-weight: bold;">SUB TOTAL:</td>
                            <td style="text-align: center; border: 1px solid gray; padding: 5px; font-weight: bold;">
                                ${{ venta.ven_subtotal }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <br>

            <!-- RESUMEN -->
            <table style="width: 50%; border-collapse: collapse; font-size: 14px; margin-left: auto;" v-if="!userAsesor">
                <tr>
                    <td style="font-weight: bold; text-align: left; padding: 3px;">Total ítems:</td>
                    <td style="text-align: right; padding: 3px;">{{ venta.total_items }}</td>
                </tr>
                <tr>
                    <td style="font-weight: bold; text-align: left; padding: 3px;">Total libros:</td>
                    <td style="text-align: right; padding: 3px;">{{ venta.total_libros }}</td>
                </tr>
                <tr v-if="venta.ven_desc_por > 0">
                    <td style="font-weight: bold; text-align: left; padding: 3px;">Descuento:</td>
                    <td style="text-align: right; padding: 3px;">{{ venta.ven_desc_por }}%</td>
                </tr>
                <tr>
                    <td style="font-weight: bold; text-align: left; padding: 3px; border-top: 2px solid #333;">TOTAL:</td>
                    <td style="text-align: right; padding: 3px; border-top: 2px solid #333; font-weight: bold;">
                        ${{ venta.ven_valor }}
                    </td>
                </tr>
            </table>

            <br><br>

            <!-- FIRMAS -->
            <table style="width: 100%; border-collapse: collapse; margin-top: 30px; text-align: center;" v-if="!userAsesor">
                <tr>
                    <td style="width: 50%; font-weight: bold;">ENTREGUÉ CONFORME</td>
                    <td style="width: 50%; font-weight: bold;">RECIBÍ CONFORME</td>
                </tr>
            </table>
            <table style="width: 100%; border-collapse: collapse; margin-top: 110px; text-align: center;" v-if="!userAsesor">
                <tr>
                    <td style="width: 50%; font-weight: bold;">PROLIPA CIA. LTDA</td>
                    <td style="width: 50%;">
                        <p>{{ venta.asesor ? venta.asesor.toUpperCase() : '' }}</p>
                        <p style="font-weight: bold;">VENDEDOR</p>
                    </td>
                </tr>
            </table>

            <div style="font-size: 10px; margin-top: 20px; text-align: left; color: #666;">
                <p>
                  Observacion Asesor:
                  {{ venta.observacion_pedido && venta.observacion_pedido !== 'null' && venta.observacion_pedido.trim() !== ''
                    ? venta.observacion_pedido
                    : 'No hay observaciones' }}
                  </p>
                <p>Observacion facturador: {{ venta.ven_observacion || 'No hay observaciones' }}</p>
                <p>Por: {{ venta.facturador_nombre }}</p>
            </div>

        </vx-card>
    </div>
</template>

<script>
import {
    mapState
} from "vuex";
import moment from "moment";
import imprimirMixin from "@/mixins/Pedidosmix";

export default {
    mixins: [imprimirMixin],
    props: {
        objectedDocumentoVenta: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            venta: {},
            detalles: [],
            day: '',
            mes: '',
            mesd: '',
            year: '',
            nombrearchivo: '',
            datosProp: '',
        };
    },
    created() {
        moment.locale('es');
        // Fecha actual para el documento
        this.day  = moment().format('DD');
        this.mes  = moment().format('MMMM');
        this.mesd = moment().format('dddd');
        this.year = moment().format('YYYY');
    },
    mounted() {
        this.cargarVenta();
    },
    computed: {
        ...mapState(['userRoot','userAsesor', 'groupFacturador']),
    },
    methods: {
        async empresa(a) {
            await this.$http.get(this.$server_url + 'GetVuser?id=' + a)
                .then(res => {
                    this.datosProp = res.data;
                    this.$vs.loading.close();
                })
                .catch(err => {
                    console.log(err);
                    this.$vs.loading.close();
                });
        },
        cargarVenta() {
            let me = this;
            if (!me.objectedDocumentoVenta.id_pedido_guia) return;
            me.$vs.loading();
            me.$http.get(me.$server_url + 'guias?listadoDocumentoVentaGuias=1&id_pedido=' + me.objectedDocumentoVenta.id_pedido_guia)
                .then((res) => {
                    if (res.data && res.data.length > 0) {
                        me.venta = res.data.find(v => v.ven_codigo === me.objectedDocumentoVenta.ven_codigo) || {};
                        me.nombrearchivo = (me.venta.ven_codigo || 'documento') + '.pdf';
                        // Cargar empresa y detalles
                        me.empresa(me.venta.id_empresa);
                        me.cargarDetalleVenta(me.venta.ven_codigo, me.venta.id_empresa);
                    }
                    me.$vs.loading.close();
                })
                .catch((err) => {
                    me.$vs.loading.close();
                    console.error(err);
                    me.$vs.notify({
                        text: 'Error al cargar el documento de venta',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle',
                    });
                });
        },
        cargarDetalleVenta(ven_codigo, id_empresa) {
            let me = this;
            me.$vs.loading();
            var url = `guias?CargarDocumentosDetallesGuias=1&ven_codigo=${ven_codigo}&id_empresa=${id_empresa}`;
            me.$http.get(me.$server_url + url)
                .then((res) => {
                    me.$vs.loading.close();
                    me.detalles = res.data;
                })
                .catch((err) => {
                    me.$vs.loading.close();
                    console.error(err);
                    me.$vs.notify({
                        text: 'Error al cargar el detalle del documento',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle',
                    });
                });
        }
    }
};
</script>

<style scoped>
.tabla2 {
    table-layout: auto;
    border-collapse: collapse;
    margin: 20px auto;
}

.tabla2 td {
    padding: 5px;
    box-sizing: border-box;
}

@media print {
    .mi-clase-de-tabla td {
        page-break-before: always;
    }
}
</style>
